// getUrlParam
// - 2025.07.09
function getUrlParam (name) {
  const searchParams = new URLSearchParams(window.location.search)

  return searchParams.get(name)
}

// getMiniProgramContext
export function getMiniProgramContext () {
  const context = {
    appKey: getUrlParam('qt_mp_appkey'),
    openId: getUrlParam('qt_mp_openid'),
    unionId: getUrlParam('qt_mp_unionid'),
    userId: getUrlParam('qt_mp_userid'),
    uuid: getUrlParam('qt_mp_uuid'),
    isClueCustomer: getUrlParam('qt_mp_is_clue_customer'),
    isClueCustomerUUID: getUrlParam('qt_mp_is_clue_customer_uuid'),
  }

  return context
}

// initializeQuickTracking
// - 2025.07.09
// - 2026.07.31
// - Restore the Mini Program's App Key for WebView pages, so traffic opened
//   from the WeChat Mini Program is attributed to its Quick Tracking
//   application. Standalone browser visits keep the Web Application's own
//   App Key.
export function initializeQuickTracking () {
  const mpContext = getMiniProgramContext()

  // appKey
  // - 2026.07.31
  // - Resolved independently of the user identifiers below: a logged-out
  //   Mini Program user still reaches the WebView with `qt_mp_appkey`
  //   present but no `qt_mp_userid`.
  const appKey = mpContext.appKey || import.meta.env.VITE_QUICK_TRACKING_APP_KEY

  aplus_queue.push({
    action: 'aplus.setMetaInfo',
    arguments: ['appKey', appKey],
  })

  aplus_queue.push({
    action: 'aplus.setMetaInfo',
    arguments: ['aplus-rhost-v', import.meta.env.VITE_QUICK_TRACKING_TRACK_DOMAIN],
  })

  // aplus_queue.push({
  //   action: 'aplus.setMetaInfo',
  //   arguments: ['DEBUG', true],
  // })

  if (
    mpContext
    && mpContext.openId
    && mpContext.unionId
    && mpContext.userId
    && mpContext.uuid
  ) {

    // _dev_id
    // - 设备 ID
    aplus_queue.push({
      action: 'aplus.setMetaInfo',
      arguments: ['_dev_id', mpContext.openId],
    })

    // openid
    // - Wechat Open Id
    aplus_queue.push({
      action: 'aplus.setMetaInfo',
      arguments: ['openid', mpContext.openId],
    })

    // _user_id
    // - User ID
    if (mpContext.userId) {
      aplus_queue.push({
        action: 'aplus.setMetaInfo',
        arguments: ['_user_id', mpContext.userId],
      })
    }

    // Append `globalproperty`
    // - 2025.07.10
    // - Append: user_uc_id, user_uuid, user_open_id, user_union_id
    // - 2025.07.11
    // - Append: user_is_clue_customer
    aplus_queue.push({
      action: 'aplus.appendMetaInfo',
      arguments: ['globalproperty', {
        user_uc_id: mpContext.userId,
        user_uuid: mpContext.uuid,
        user_open_id: mpContext.openId,
        user_union_id: mpContext.unionId,
        user_is_clue_customer: mpContext.isClueCustomer,
        user_is_clue_customer_uuid: mpContext.isClueCustomerUUID,
      }],
    })

    // Record user profile
    // - 2025.07.11
    // - Append: user_is_clue_customer
    aplus_queue.push({
      action: 'aplus.record',
      arguments: ['$$_user_profile', 'OTHER', {
        user_uc_id: mpContext.userId,
        user_uuid: mpContext.uuid,
        user_open_id: mpContext.openId,
        user_union_id: mpContext.unionId,
        user_is_clue_customer: mpContext.isClueCustomer,
        user_is_clue_customer_uuid: mpContext.isClueCustomerUUID,
      }],
    })
  }
}

